import cx from 'clsx';
import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as MultiSortIcon } from '@assets/svg/multi-sort.svg';
import { ReactComponent as TableSortIcon } from '@assets/svg/table-sort.svg';

import Button from '@components/uikit/Button/Button';
import RadioButton from '@components/uikit/RadioButton/RadioButton';

import useTranslation from '@hooks/useTranslation';

import type { ITableSorting } from '@model/tableSorting';

import style from './style.module.scss';

interface IProps {
  id: number;
  sortingTooltipId: string;
  sorting: ITableSorting;
  sortingOptions: { label: string; value: string }[];
  onChange: (key: string, fieldName: string) => void;
  resetSorting: () => void;
}

const MultiTableSortMenu: React.FC<IProps> = ({
  id,
  sortingTooltipId,
  sorting,
  sortingOptions,
  onChange,
  resetSorting,
}) => {
  const { t } = useTranslation();

  const TOOLTIP_ID = `multi-sorting-menu-${id}`;

  const selectedOption = sortingOptions.find((sortingOption) => sorting.id === sortingOption.value);
  return (
    <div className={style.multiTableSortMenuWrapper}>
      <div data-tooltip-id={sortingTooltipId} data-tooltip-content={selectedOption?.value || 'unsorted'}>
        <MultiSortIcon data-tooltip-id={TOOLTIP_ID} className={style.multiSortIcon} />
      </div>

      <Tooltip
        id={TOOLTIP_ID}
        place="bottom-end"
        className={style.multiTableSortMenu}
        disableStyleInjection
        openOnClick
        clickable
        render={() => {
          return (
            <div className={style.tooltipContainer}>
              <div className={style.textContainer}>
                <span>{t('Sort by')}</span>
                <div className={cx({ [style.hideResetButton]: !selectedOption })}>
                  <Button type="secondary" text={t('Reset')} onClick={resetSorting} />
                </div>
              </div>
              <div className={style.radioButtonsContainer}>
                {sortingOptions.map((sortingOption) => (
                  <div
                    className={style.radioButtonContainer}
                    onClick={() => onChange(sortingOption.value, sortingOption.label)}
                    key={sortingOption.value}
                  >
                    <RadioButton
                      id={sortingOption.value}
                      checked={sorting.id === sortingOption.value}
                      label={sortingOption.label}
                      readOnly
                      disabled
                    />
                    <TableSortIcon className={style.sortIcon} />
                  </div>
                ))}
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};
export default MultiTableSortMenu;
